import React, { Fragment, useEffect, useState } from "react"
import Layout from "../Layout"
import Hero from "../Hero"
import Breadcrumb from "../Breadcrumb"
import Searcher from "../Searcher"
import parse from "react-html-parser"
import NewsTabImage from "../NewsTab/NewsTabImage"
import NewsTabVideos from "../NewsTab/NewsTabVideos"
import NewsTabItem from "../NewsTab/NewsTabItem"
import { useAxiosClient } from "../../service/useAxiosClient"
import NewsTabActivities from "../NewsTab/NewsTabActivities"
import { navigate } from "gatsby"
import TitlePage from "../TitlePage"
import SocialButtons from "../SocialButton/SocialButtons"
import TopicalityMenu from "../TopicalityPage/TopicalityMenu"
import DownloadBtn from "../DownloadBtn"
import { searchT } from "../../commons/commons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useReplaceIframe } from "../../hooks/useReplaceIframe"
import { NonAssociateInscriptionForm } from "../Form/NonAssociateInscriptionForm"
import styled from "styled-components"

const Success = styled.div`
  background: white;
  border: 1px solid green;
  padding: 10px;
  margin-bottom: 10px;

  & > span {
    color: green;
  }
`

function ActivityTab({ params = {}, pageContext = {}, location }) {
  const id = pageContext.id || params.id
  const ctypk = pageContext.ctypk || params.ctypk
  const categoryPk = parseInt(ctypk)
  const [activityTab, setActivityTab] = useState({})
  const [showInscription, setShowInscription] = useState(false)
  const [activityTabCourse, setActivityTabCourse] = useState()
  const [activitiesCategories, setActivitiesCategories] = useState([])
  const [inscriptionSuccessMessage, setInscriptionSuccessMessage] = useState("")
  const { replacedIframeDescription } = useReplaceIframe(
    activityTab.description
  )
  const [, requestTrigger] = useAxiosClient({}, { manual: true })

  const [, getActivityData] = useAxiosClient(
    {
      url: `/activities/${id}/web/activity/`,
      method: "GET",
    },
    { manual: true }
  )

  const [, getCategories] = useAxiosClient(
    {
      url: `/activities/categories/web/`,
      method: "GET",
    },
    { manual: true }
  )
  const getCourseRequest = activityId => {
    requestTrigger({
      url: `/courses/intranet/`,
      method: "GET",
      params: {
        activity: activityId,
      },
    }).then(({ data }) => data.length && setActivityTabCourse(data[0]))
  }

  useEffect(() => {
    getActivityData().then(({ data }) => {
      data && setActivityTab(data[0])
      getCourseRequest(data[0].id)
      if (data.length === 0) {
        navigate("/")
      }
    })
    getCategories().then(
      ({ data }) => data && data.length && setActivitiesCategories(data)
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const path = [
    { label: "Inicio", to: "/" },
    { label: "Servicios y actividades", to: "/servicios-y-actividades" },
    {
      label: activityTab?.category?.title,
      to: `/servicios-y-actividades/${activityTab?.category?.pk}/${activityTab?.category?.slug}`,
    },
    { label: activityTab?.title },
  ]

  const renderImageTab = () => {
    if (!activityTab?.image || !activityTab?.print_image_block) {
      return <Fragment />
    }
    return (
      <img
        className={
          activityTab.image_align === 2
            ? "ActivityTab-image-position"
            : "ActivityTab-image-position right"
        }
        src={activityTab.image}
        alt=""
      />
    )
  }

  const renderDocuments = () => {
    let pdfs = []
    if (activityTab?.attached_one_title) {
      pdfs = [
        ...pdfs,
        <div className="Documents-item">
          <a
            className="Documents-link"
            href={activityTab?.attached_one}
            target="_blank"
            rel="noopener noreferrer"
          >
            {activityTab?.attached_one_title}
            <i className="fas fa-file-alt"></i>
          </a>
        </div>,
      ]
    }
    if (activityTab?.attached_two_title) {
      pdfs = [
        ...pdfs,
        <div className="Documents-item">
          <a className="Documents-link" href={activityTab?.attached_two}>
            {activityTab?.attached_two_title}
            <i className="fas fa-file-alt"></i>
          </a>
        </div>,
      ]
    }
    return pdfs.length ? pdfs : <Fragment />
  }

  const renderGallery = () => {
    if (!activityTab?.gallery) {
      return <Fragment />
    }
    return <NewsTabImage list={activityTab?.gallery} />
  }

  const renderVideos = () => {
    if (
      !activityTab?.videos ||
      (Array.isArray(activityTab?.videos) && !activityTab?.videos.length)
    ) {
      return <Fragment />
    }
    return <NewsTabVideos listVideo={activityTab?.videos} />
  }

  const getRoute = data =>
    navigate(`/servicios-y-actividades/${data.pk}/${data.slug}`)

  const getCategory = data => {
    getRoute(data)
  }

  const handleShowInscription = e => {
    e.preventDefault()
    setShowInscription(prev => !prev)
  }

  const handleSearchBar = filters => {
    navigate(`/servicios-y-actividades/buscador/?${searchT(filters)}`, {
      state: { filters: filters },
    })
  }

  const renderInscriptions = () => {
    if (!activityTab?.private_registration && !activityTab?.public_registration)
      return null
    if (activityTabCourse) {
      if (activityTabCourse.total_attendants >= activityTabCourse.capacity) {
        return (
          <h4 style={{ fontWeight: 600, color: "#112149" }}>
            Inscripciones cerrada por aforo completo.
          </h4>
        )
      }
    }
    if (!activityTabCourse) {
      return (
        <h4 style={{ fontWeight: 600, color: "#112149" }}>
          Inscripciones cerrada. Fecha de inscripción caducada.
        </h4>
      )
    }
    return (
      <div className="ActivityTab-section">
        <div className="ActivityTab-sectionTitle mb-3">Inscripciones</div>
        {inscriptionSuccessMessage.length > 0 && (
          <Success>
            <span>{inscriptionSuccessMessage}</span>
          </Success>
        )}
        <divc className="ActivityTab-sectionContent">
          {activityTab?.public_registration && (
            <DownloadBtn
              text="Inscripción no asociados"
              variant="dark bigIcon noUnderline small px-0 pt-0"
              icon="far fa-check-square"
              className="mb-0"
              onClick={handleShowInscription}
              reverse
            />
          )}
          {showInscription && (
            <NonAssociateInscriptionForm
              courseId={activityTabCourse.pk}
              requestTrigger={requestTrigger}
              computableHours={activityTabCourse.hours}
              capacity={activityTabCourse.capacity}
              attendants={activityTabCourse.total_attendants}
              setSuccessMessage={setInscriptionSuccessMessage}
              handleClose={() => setShowInscription(false)}
            />
          )}
          {activityTab?.private_registration && (
            <DownloadBtn
              text="Inscripción asociados"
              variant="dark bigIcon noUnderline small p-0 m-0"
              icon="far fa-check-square"
              link={`${process.env.GATSBY_INTRANET_URL}${location.pathname}`}
              blank={false}
              reverse
            />
          )}
        </divc>
      </div>
    )
  }
  return (
    <Layout>
      <TitlePage
        title={activityTab?.title || pageContext.title}
        description={
          activityTab?.description_dates_calendar || pageContext.description
        }
        image={activityTab?.image || pageContext.image}
        url={location.pathname}
      />
      <Hero
        image="/imgs/servicios-actividades-ret.jpg"
        text={activityTab?.category?.title}
      />
      <div className="container950">
        <Breadcrumb path={path} />
        <Searcher
          onChangeFilter={handleSearchBar}
          selectCategory={activitiesCategories}
        />
        <div className="row efpa-row">
          <div className="col-12 col-md-3 Topicality-padding-col">
            <TopicalityMenu
              list={activitiesCategories}
              showTitle={false}
              className="LayoutTest-options"
              useGalleryItem={false}
              getCategory={getCategory}
              initialCategory={categoryPk || activityTab?.category?.pk}
              useAllData
            />
          </div>
          <div className="col-12 col-md-9 Topicality-col-9">
            <span className="ActivityTab-title">{activityTab?.title}</span>
            <span className="ActivityTab-date">
              {activityTab?.description_dates ||
                activityTab?.description_dates_calendar}
            </span>
            <p className="ActivityTab-subtitle">
              {activityTab?.place_course}{" "}
              {activityTab?.link_place_course && (
                <a
                  className="ActivityTab-link"
                  href={activityTab?.link_place_course}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Ver lugar
                </a>
              )}
            </p>
            <span className="ActivityTab-subtitle">{activityTab?.summary}</span>
            {renderInscriptions()}
            <div className="ActivityTab-content mb-3 d-inline-block">
              {renderImageTab()}
              {parse(replacedIframeDescription)}
            </div>
            {activityTab?.embed_code && (
              <div
                dangerouslySetInnerHTML={{ __html: activityTab?.embed_code }}
              />
            )}
            <SocialButtons title={activityTab?.title} />
            {activityTab?.attached_one && (
              <div className="ActivityTab-section">
                <div className="ActivityTab-sectionTitle">
                  Documentos actividad
                </div>
                <div className="Documents">{renderDocuments()}</div>
              </div>
            )}
            {activityTab?.twitter_hashtag && (
              <div className="NewsTab-borderTop">
                <div className="ActivityTab-twitter">
                  <FontAwesomeIcon
                    icon={["fab", "x-twitter"]}
                    className="twitter-social-icon"
                  />
                  <span>
                    Te invitamos a participar en X, haciendo llegar tus
                    comentarios a{" "}
                    <a
                      href={`https://twitter.com/hashtag/${activityTab?.twitter_hashtag}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {`#${activityTab?.twitter_hashtag}`}
                    </a>
                  </span>
                </div>
              </div>
            )}
            {renderGallery()}
            {renderVideos()}
            {Array.isArray(activityTab?.activities) &&
              !!activityTab?.activities.length && (
                <NewsTabActivities activities={activityTab?.activities} />
              )}
            {Array.isArray(activityTab?.publications) &&
              !!activityTab?.publications.length && (
                <NewsTabItem
                  news={activityTab?.publications}
                  categorySlug={activityTab?.category.slug}
                  title="Noticias relacionadas:"
                />
              )}
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default ActivityTab
